import { EditorModes, ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../types";
import { runCopperOverlapDrc } from "./copperOverlapDetection";
import { serializeInputs } from "./serde";
export class OverlappingCopperValidator {
    computeFunction;
    reviewType = ReviewType.DesignRuleCheckOverlappingCopper;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    constructor(computeFunction = runCopperOverlapDrc) {
        this.computeFunction = computeFunction;
    }
    async checkForProblems(inputs) {
        try {
            const serializedInputs = serializeInputs(inputs);
            const { collisionKeys } = await this.computeFunction(serializedInputs);
            return {
                error: false,
                problemTypeKey: this.problemTypeKey,
                foundProblems: collisionKeys.map((ck) => ({
                    problemTypeKey: this.problemTypeKey,
                    key: `${this.problemTypeKey}_${ck}`,
                    affectedItems: ck.split("+").map((uid) => ({ type: "pcbLayoutNode", uid })),
                    affectedViews: [EditorModes.pcb],
                })),
            };
        }
        catch (e) {
            return {
                error: `Copper overlap error:${e?.message} `,
                problemTypeKey: this.problemTypeKey,
                foundProblems: [],
            };
        }
    }
}
//# sourceMappingURL=pcbDrcCopperOverlapMain.js.map